module.exports = __webpack_public_path__ + "static/media/cnito-sizzle-pt.64849e92.mp4";